import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import WaveFollowersList from "@/components/waves/followers/WaveFollowersList";
interface BrainRightSidebarFollowersProps {
  readonly wave: ApiWave;
  readonly closeFollowers: () => void;
}
const BrainRightSidebarFollowers: React.FC<BrainRightSidebarFollowersProps> = t0 => {
  const $ = _c(3);
  const {
    wave,
    closeFollowers
  } = t0;
  let t1;
  if ($[0] !== closeFollowers || $[1] !== wave) {
    t1 = <WaveFollowersList wave={wave} onBackClick={closeFollowers} />;
    $[0] = closeFollowers;
    $[1] = wave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BrainRightSidebarFollowers;